import React from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../config/routes';

interface Props {
    active: 'overview' | 'team' | 'players' | 'matches' | 'prep';
}

const items: { key: Props['active']; label: string; link: string }[] = [
    { key: 'overview', label: 'Overview', link: Routes.ROUTE_INSIGHTS },
    { key: 'team', label: 'Team', link: Routes.ROUTE_INSIGHTS_TEAM },
    { key: 'players', label: 'Players', link: Routes.ROUTE_INSIGHTS_PLAYERS },
    { key: 'matches', label: 'Matches', link: Routes.ROUTE_INSIGHTS_MATCHES },
    { key: 'prep', label: 'H2H', link: Routes.ROUTE_INSIGHTS_PREP },
];

const InsightsNav: React.FC<Props> = ({ active }) => (
    <nav className="insightsNav" aria-label="Insights sections">
        {items.map((item) => (
            <Link
                key={item.key}
                to={item.link}
                className={item.key === active ? 'insightsNavItem isActive' : 'insightsNavItem'}
            >
                {item.label}
            </Link>
        ))}
    </nav>
);

export default InsightsNav;
